import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { Outlet } from "react-router-dom";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";
const ReportingBoundaryPage = lazy(
  () => import("./pages/ReportingBoundaryPage"),
);
const AddReportingYearPage = lazy(
  () => import("./components/AddReportingYearPage"),
);

export const reportingBoundaryRoutes = [
  {
    path: PATHS.ESG_REPORTING_BOUNDARY,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.REPORTING_BOUNDARY}>
        <ReportingBoundaryPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "reporting_boundary", action: "view" } },
  },
  {
    path: PATHS.ESG_REPORTING_BOUNDARY_ADD,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.REPORTING_BOUNDARY}>
        <AddReportingYearPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "reporting_boundary", action: "create" },
    },
  },
  {
    path: PATHS.ESG_REPORTING_BOUNDARY_EDIT,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.REPORTING_BOUNDARY}>
        <AddReportingYearPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "reporting_boundary", action: "update" },
    },
  },
];
